export const PARAMÈTRE_SITUATION = 'situation'
export const PARAMÈTRE_UNITÉ = 'unite'
